import React, { useState, useEffect } from "react";
import { UserContext } from "../contexts/UserContext";

export const UserProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    // Retrieve the profile from localStorage when the component mounts
    const savedProfile = localStorage.getItem("userProfile");
    if (savedProfile) {
      setProfile(JSON.parse(savedProfile));
    }
  }, []);

  useEffect(() => {
    // Save the profile to localStorage whenever it changes, if it's not null
    if (profile) {
      localStorage.setItem("userProfile", JSON.stringify(profile));
    }
  }, [profile]);

  return (
    <UserContext.Provider value={{ profile, setProfile }}>
      {children}
    </UserContext.Provider>
  );
};
